import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import ConvertiblesApi from '../../../../api/ConvertiblesApi'
import AdminEditConvertibleForm from './AdminEditConvertibleForm'
import { AdminEditEntityWrapper } from '../../shared/AdminEditEntityWrapper'
import { ConvertibleSingleItem } from '@finance-lab/utils/types'

const convertiblesApi = new ConvertiblesApi()

const AdminEditConvertible = () => {
    const [convertible, setConvertible] = useState<ConvertibleSingleItem | null>(null)
    const { convertibleId } = useParams()
    const { t } = useTranslation()

    const fetchData = useCallback(async (id: string) => {
        const conv = await convertiblesApi.findByConvertibleId(id, false)
        setConvertible(conv)
    }, [])

    useEffect(() => {
        if (!convertibleId) return
        void fetchData(convertibleId)
    }, [convertibleId, fetchData])

    const pageTitle = t('site.convertibles.detailsTitle', { name: convertible?.convertibleName || '' })

    return (
        <AdminEditEntityWrapper
            companyId={convertible?.companyId}
            entityLink={`/convertibles/${convertibleId}`}
            pageTitle={pageTitle}
        >
            {convertibleId && convertibleId !== 'new' && convertible && (
                <AdminEditConvertibleForm convertible={convertible} refetchData={fetchData} />
            )}
        </AdminEditEntityWrapper>
    )
}

export default AdminEditConvertible
